import { typography } from 'styles/typography'

const themeStyles = colors => {
  const styles = {
    authTemplate: {
      childContainer: {
        padding: '37px 70px 29px 70px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
      }
    },
    container: {
      ...typography.font,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      padding: '0',
      height: '100%'
    },
    title: {
      color: colors.approxBlack,
      fontSize: 28,
      fontWeight: 700,
      lineHeight: '34px',
      marginBottom: 24
    },
    subTitle: {
      color: colors.primary,
      fontSize: 20,
      fontWeight: 400,
      lineHeight: '23px',
      marginBottom: 20
    },
    desc: {
      color: colors.secondaryGray,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '16px',
      marginBottom: 0
    },
    buttonSign: (isMobile = false) => {
      return {
        button: {
          button: {
            ...typography.font,
            letterSpacing: '0.5px',
            fontSize: 13,
            backgroundColor: colors.primary,
            margin: '0 auto 0 0',
            display: 'block',
            width: isMobile ? '100%' : '330px',
            marginTop: '14px'
          }
        }
      }
    },
    buttonCreateAccount: (isMobile = false) => {
      return {
        button: {
          ...typography.font,
          fontSize: 13,
          margin: '0 auto 0 0',
          display: 'block',
          width: isMobile ? '100%' : '330px',
          marginTop: '14px',
          backgroundColor: colors.textWhite,
          border: `1px solid ${colors.primary}`,
          color: colors.primary
        }
      }
    },
    linksContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      marginTop: '25px'
    },
    textAlignmentCenter: {
      textAlign: 'center'
    },
    text: {
      fontFamily: 'Barlow',
      fontSize: 14,
      lineHeight: '16px',
      color: colors.primary
    },
    link: {
      fontWeight: 400,
      color: colors.primary
    },
    additionalLinkStyle: {
      fontWeight: 500,
      cursor: 'pointer'
    },
    divider: {
      margin: '32px -70px 25px -70px',
      borderTop: `1px solid ${colors.pannikin}`
    },
    errorMessage: {
      marginTop: 5,
      paddingLeft: 5,
      ...typography.fontBold,
      lineHeight: '20px',
      color: colors.red
    },
    modal: {
      header: {
        justifyContent: 'end'
      },
      content: {
        fontSize: 20,
        fontWeight: 400,
        lineHeight: '30px',
        padding: '20px'
      }
    }
  }
  styles.linkMt = { ...styles.link, display: 'inline-block' }
  styles.signInText = { ...styles.text, fontWeight: 'bold', cursor: 'pointer' }
  styles.forgotPasswordContainer = {
    ...styles.textAlignmentCenter,
    ...styles.text,
    marginBottom: 25,
    letterSpacing: -0.05
  }
  styles.signUpText = { ...styles.text, ...styles.additionalLinkStyle, fontWeight: 'bold' }
  styles.highlightedText = { ...styles.text, ...styles.additionalLinkStyle, color: 'inherit', lineHeight: '20px' }
  return styles
}
export default themeStyles
